import { sendOTPApi } from 'entities/sendOTP/model';
import { HTTP_METHODS } from 'shared/consts';
import { IOTPItem } from 'entities/sendOTP/types';

const getSendOTPApi = sendOTPApi.injectEndpoints({
  endpoints: (builder) => ({
    getOTP: builder.query<IOTPItem[], null>({
      query: () => ({
        url: '/callpassword/admin/methodprioritys/',
        method: HTTP_METHODS.GET,
      }),
      providesTags: ['SendOTP'],
    }),
  }),
});

export const { useGetOTPQuery } = getSendOTPApi;
